import {UPDATE_POSTS_START} from "../../types";

export const update_posts = (payload) => ({
    type: UPDATE_POSTS_START,
    payload,
});
